import logo from "../../../../assets/img/organicWhiteLogo.png";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uiAction } from "../../../../Redux/Slices/uiSlice";
import useWindowWidth from "../../../../Hooks/useWindow";

const BrandLogo = () => {

    const dispatch = useDispatch();
    const handleToggle = () => {
        dispatch(uiAction.setSideBarToggle());
    }

    const width = useWindowWidth();

    return (
        <div className="navbar-logo">
            <button
                className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarTopCollapse"
                aria-controls="navbarTopCollapse"
                aria-expanded="true"
                aria-label="Toggle Navigation"
                onClick={handleToggle}
            >
                <span className="navbar-toggle-icon text-light">
                    <span className="toggle-line text-light" />
                </span>
            </button>

            <Link className="navbar-brand" to="/dashboard">
                <img style={width > 990 ? { width: "100px", height: "55px", margin: "10px" } : { width: "100px", height: "50px", margin: "10px" }} src={logo} alt="Logo" />
            </Link>
        </div>
    )
}

export default BrandLogo;
